const Q = require('q');
const _ = require('underscore');
const logger = require('utilities/logger');
const model = require('model/model');
const utilities = require('utilities');

const discoveryService = require('services/discoveryService');
const libraryService = require('services/libraryService');
const productService = require('services/productService');
const recommendationService = require('services/recommendationService');

let prmsMap = {};

let favoriteMap = {};
let readNextMap = {};
let recommendationMap = {};
let readMap = {};

const sortByCreationDateDesc = (a, b) => {
	if (a.c > b.c) {
		return -1;
	} else if (a.c < b.c) {
		return 1;
	} else {
		return 0;
	}
};

const updateLibraryProducts = () => {
	let libraryProducts = {};
	let pidPrmsList = [];

	let productIds = Object.keys(readNextMap || {});
	productIds = productIds.concat(Object.keys(readMap || {}));
	productIds = productIds.concat(Object.keys(favoriteMap || {}));
	productIds = productIds.concat(Object.keys(recommendationMap || {}));

	productIds.forEach(pid => {
		if (!libraryProducts[pid]) {
			libraryProducts[pid] = {
				recommended: false,
				favorite: false,
				read: false,
				readNext: false
			};
			let prms = productService
				.get(pid)
				.then(product => {
					libraryProducts[pid] = _.assign({}, product, {
						favorite: !!favoriteMap[pid],
						read: !!readMap[pid],
						readNext: !!readNextMap[pid] && !readMap[pid],
						recommended: !!recommendationMap[pid],
						n: readMap[pid] && readMap[pid].n
					});
				})
				.catch(() => {
					logger.error('Product not found. ', pid);
				});
			pidPrmsList.push(prms);
		}
	});

	return Q.all(pidPrmsList).then(() => {
		let read = [];
		let favorites = [];
		let recommended = [];
		let readNext = [];

		Object.keys(libraryProducts || {}).forEach(p => {
			let product = libraryProducts[p];
			if (product.read) {
				read.push(product);
				if (product.favorite) {
					favorites.push(product);
				}
			} else if (product.recommended) {
				recommended.push(_.assign({}, product, recommendationMap[p]));
			} else if (product.readNext) {
				readNext.push(product);
			}
		});

		//Sort each respective array by it's creation date
		readNext.sort(sortByCreationDateDesc);
		read.sort(sortByCreationDateDesc);
		favorites.sort(sortByCreationDateDesc);
		recommended.sort(sortByCreationDateDesc);

		model.set('libraryProducts', libraryProducts);
		model.set('libraryReadingList', readNext);
		model.set('libraryArticlesRead', read);
		model.set('libraryFavorites', favorites);
		model.set('libraryRecommendations', recommended);

		let activeProduct = model.get('activeProduct');
		if (activeProduct && activeProduct.uuid) {
			let pid = activeProduct.uuid;
			model.set(
				'activeProduct',
				_.assign({}, activeProduct, {
					favorite: !!favoriteMap[pid],
					read: !!readMap[pid],
					readNext: !!readNextMap[pid] && !readMap[pid],
					recommended: !!recommendationMap[pid],
					n: readMap[pid] && readMap[pid].n
				})
			);
		}

		return libraryProducts;
	});
};

const searchLibrary = (f = 0, q, t, g, features) => {
	return discoveryService
		.searchLibrary({
			f,
			q,
			t,
			g,
			features
		})
		.then(resp => {
			if (resp && resp.hits) {
				let results = model.get('libraryResults');
				if (f === 0) {
					results = resp;
				} else if (results && results.total && f < results.total) {
					results.hits = results.hits.concat(resp.hits);
					results.total = resp.total;
				}
				model.set('libraryResults', results);
			}
		});
};

const getFavorites = () => {
	let userContext = model.get('userContext');

	if (!userContext.classCode) {
		model.set('libraryFavorites', {});
		return updateLibraryProducts();
	}

	return (
		libraryService
			.getFavorites()
			// eslint-disable-next-line consistent-return
			.then(resp => {
				if (resp && resp.length) {
					favoriteMap = resp.reduce((acc, item) => {
						if (item && item.p) {
							acc[item.p] = true;
						}
						return acc;
					}, {});
					return updateLibraryProducts();
				}
			})
			.then(libraryProducts => {
				return model.get('libraryFavorites');
			})
	);
};

const addFavorite = p => {
	let key = 'favorite/' + p;

	if (prmsMap[key]) {
		return prmsMap[key];
	}

	prmsMap[key] = libraryService
		.favoritesAdd({
			p
		})
		// eslint-disable-next-line consistent-return
		.then(resp => {
			if (resp) {
				favoriteMap[p] = true;
				return updateLibraryProducts();
			}
		})
		.catch(err => {
			if (err.status === 409 && err.code === 1112) {
				favoriteMap[p] = true;
				return updateLibraryProducts();
			} else {
				throw err;
			}
		})
		.finally(libraryProducts => {
			delete prmsMap[key];
			return model.get('libraryFavorites');
		});
	return prmsMap[key];
};

const removeFavorite = p => {
	let key = 'favorite/' + p;

	if (prmsMap[key]) {
		return prmsMap[key];
	}

	prmsMap[key] = libraryService
		.favoritesRemove({
			p
		})
		// eslint-disable-next-line consistent-return
		.then(resp => {
			if (resp) {
				delete favoriteMap[p];
				return updateLibraryProducts();
			}
		})
		.catch(err => {
			if (err.status === 409 && err.code === 1112) {
				delete favoriteMap[p];
				return updateLibraryProducts();
			} else {
				throw err;
			}
		})
		.finally(libraryProducts => {
			delete prmsMap[key];
			return model.get('libraryFavorites');
		});
	return prmsMap[key];
};

const getReadingList = p => {
	let userContext = model.get('userContext');

	if (!userContext.classCode) {
		model.set('libraryReadingList', {});
		return updateLibraryProducts();
	}

	return (
		libraryService
			.getReadingList()
			// eslint-disable-next-line consistent-return
			.then(resp => {
				if (resp && resp.length) {
					readNextMap = resp.reduce((acc, item) => {
						if (item && item.p) {
							acc[item.p] = true;
						}
						return acc;
					}, {});
					return updateLibraryProducts();
				}
			})
			.then(libraryProducts => {
				return model.get('libraryReadingList');
			})
	);
};

const addReadingList = p => {
	let key = 'read/' + p;

	if (prmsMap[key]) {
		return prmsMap[key];
	}

	prmsMap[key] = libraryService
		.readingListAdd({
			p
		})
		// eslint-disable-next-line consistent-return
		.then(resp => {
			if (resp) {
				readNextMap[p] = true;
				return updateLibraryProducts();
			}
		})
		.catch(err => {
			if (err.status === 409 && err.code === 1112) {
				readNextMap[p] = true;
				return updateLibraryProducts();
			} else {
				throw err;
			}
		})
		.finally(libraryProducts => {
			delete prmsMap[key];
			return model.get('libraryReadingList');
		});

	return prmsMap[key];
};

const removeReadingList = p => {
	let key = 'read/' + p;

	if (prmsMap[key]) {
		return prmsMap[key];
	}

	prmsMap[key] = libraryService
		.readingListRemove({
			p
		})
		// eslint-disable-next-line consistent-return
		.then(resp => {
			if (resp) {
				delete readNextMap[p];
				return updateLibraryProducts();
			}
		})
		.catch(err => {
			if (err.status === 409 && err.code === 1112) {
				delete readNextMap[p];
				return updateLibraryProducts();
			} else {
				throw err;
			}
		})
		.finally(libraryProducts => {
			delete prmsMap[key];
			return model.get('libraryReadingList');
		});
	return prmsMap[key];
};

const studentGetArticlesRead = () => {
	let userContext = model.get('userContext');

	if (!userContext.classCode) {
		model.set('libraryArticlesRead', {});
		return updateLibraryProducts();
	}

	return (
		libraryService
			.studentGetArticlesRead()
			// eslint-disable-next-line consistent-return
			.then(resp => {
				if (resp && resp.length) {
					readMap = resp.reduce((acc, item) => {
						if (item && item.p) {
							let parse = utilities.parseProductUUIDAndVersion(item.p);
							let uuid = parse.uuid;
							// 'p' should be unversioned always,
							// 'id' should be exactly what is persisted (versioned)
							acc[uuid] = { p: uuid, id: item.p, n: item.n };
						}
						return acc;
					}, {});
					return updateLibraryProducts();
				}
			})
			.then(libraryProducts => {
				return model.get('libraryArticlesRead');
			})
	);
};

//markArticleRead MUST BE VERSIONED
const markArticleRead = (p, g) => {
	let parse = utilities.parseProductUUIDAndVersion(p);
	let uuid = parse.uuid;

	if (readMap[uuid]) {
		return Q.reject();
	}

	return (
		libraryService
			.readArticle({
				p,
				g
			})
			// eslint-disable-next-line consistent-return
			.then(resp => {
				if (resp && resp.p) {
					readMap[uuid] = { p: uuid, id: p };
					return updateLibraryProducts();
				}
			})
			.catch(err => {
				if (err.status === 409 && err.code === 1112) {
					readMap[uuid] = { p: uuid, id: p };
					return updateLibraryProducts();
				} else {
					throw err;
				}
			})
			.finally(libraryProducts => {
				return model.get('libraryArticlesRead');
			})
	);
};

const submitArticleNote = (p, n) => {
	let parse = utilities.parseProductUUIDAndVersion(p);
	let uuid = parse.uuid;

	if (!readMap[uuid]) {
		return Q.reject();
	} else {
		// Match 'p' to exactly what was marked read
		p = readMap[uuid].id;
	}

	return libraryService
		.submitArticleNote({
			p,
			n
		})
		.then(resp => {
			let prms = Q();
			if (resp && resp.ok) {
				let product = readMap[uuid];
				readMap[uuid] = _.assign({}, product, {
					n
				});
				prms = updateLibraryProducts();
			}
			return prms;
		});
};

const teacherGetArticlesRead = (cc, uid) => {
	return libraryService
		.teacherGetArticlesRead({
			cc,
			uid
		})
		.then(resp => {
			let pidPrmsList = [];
			if (resp && resp.length) {
				resp.forEach(result => {
					let pid = result.p;
					let pidPrms = productService
						.get(pid)
						.then(product => {
							return _.assign({}, product, result);
						})
						.catch(e => logger.error(e));
					pidPrmsList.push(pidPrms);
				});
			}
			return Q.all(pidPrmsList);
		})
		.then(products => {
			let results = model.get('teacherLibraryResults') || {};
			model.set(
				'teacherLibraryResults',
				_.assign({}, results, {
					[uid]: products
				})
			);
			return results;
		});
};

const setHideStudentLibraryPromo = () => {
	const { uid } = model.get('userContext');
	let hideStudentLibraryPromo = model.get('hideStudentLibraryPromo') || [];
	if (!hideStudentLibraryPromo.includes(uid)) {
		hideStudentLibraryPromo.push(uid);
		model.set('hideStudentLibraryPromo', hideStudentLibraryPromo);
	}
};

const getStudentSettings = () => {
	let userContext = model.get('userContext');

	if (!userContext.classCode) {
		model.set('studentLibrarySettings', {});
		return updateLibraryProducts();
	}

	return libraryService.getStudentSettings().then(settings => {
		if (settings) {
			setHideStudentLibraryPromo();
		}
		model.set('studentLibrarySettings', settings);
	});
};

const setStudentSettings = (t, g, skf) => {
	return libraryService.setStudentSettings({
		t,
		g,
		skf
	});
};

const getLibraryProductsByGenre = (genre, g) => {
	return discoveryService.getLibraryProductsByGenre({
		genre,
		g
	});
};

const getLibraryProductsBySKF = (skf, g) => {
	return discoveryService.getLibraryProductsBySKF({
		skf,
		g
	});
};

const getNewLibraryProducts = g => {
	return discoveryService
		.getNewLibraryProducts({
			g
		})
		.then(resp => {
			if (resp && resp.hits && resp.hits.length) {
				model.set('newLibraryProducts', resp.hits);
			}
			return resp;
		});
};

const getPopularLibraryProducts = g => {
	return discoveryService
		.getPopularLibraryProducts({
			g
		})
		.then(resp => {
			if (resp && resp.hits && resp.hits.length) {
				model.set('popularLibraryProducts', resp.hits);
			}
			return resp;
		});
};

const getArticlesYouMightLike = g => {
	return recommendationService
		.studentLibrarySimilar({
			g
		})
		.then(result => {
			var recommendations = [];

			result.hits.forEach(function (hit) {
				recommendations.push(hit);
			});

			model.set('articlesYouMightLike', recommendations);
		});
};

const getLibrarySuggestions = (pid, pt, g, exclusion) => {
	return discoveryService
		.libraryReadNext({
			pid,
			pt,
			g,
			exclusion
		})
		.then(resp => {
			this.loading = false;
			let hits = null;
			if (resp && resp.hits) {
				hits = resp.hits;
			}
			return hits;
		});
};

const setActiveProduct = pid => {
	let libraryProducts = model.get('libraryProducts') || {};
	let parse = utilities.parseProductUUIDAndVersion(pid);
	let uuid = parse.uuid;
	let lp = libraryProducts[uuid];
	if (lp) {
		model.set('activeProduct', lp);
		return Q(lp);
	} else {
		return productService.get(pid).then(p => {
			if (p) {
				model.set('activeProduct', p);
			}
			return p;
		});
	}
};

module.exports = {
	searchLibrary,
	getFavorites,
	addFavorite,
	removeFavorite,
	getReadingList,
	addReadingList,
	removeReadingList,
	studentGetArticlesRead,
	markArticleRead,
	submitArticleNote,
	teacherGetArticlesRead,
	getStudentSettings,
	setStudentSettings,
	getLibraryProductsByGenre,
	getLibraryProductsBySKF,
	getNewLibraryProducts,
	getPopularLibraryProducts,
	getArticlesYouMightLike,
	getLibrarySuggestions,
	setActiveProduct,
	setHideStudentLibraryPromo
};
